import React from "react";

function Box({width, height, direction, justify, align, style, children,className}) {
    return (
        <div
            className={className}
            style={{
            width: width ?? "100%",
            height: height ?? "100%",
            borderRadius: 16,
            boxShadow: "0px 2px 6px rgba(0, 111, 128, 0.08)",
            padding: 20,
            backgroundColor: "white",
            display: "flex",
            flexDirection: direction,
            alignItems: align ?? "center",
            justifyContent: justify,
            boxSizing: "border-box",
            ...style
        }}>
            {children}
        </div>
    );
}

export default Box;
